import { api } from '$utils/apiRequester'
import config from '$utils/config'

/**
 *  unprotectedUrls: all urls that should not be protected with the accessToken.
 *  If api return a 401, we do not redirect to the register view
 */
const getUnprotectedUrls = () => {
  const ululeMe = config.get('api').ulule.url + '/me'
  return [ululeMe]
}

/**
 * unAuthorizedAPIError: redirect to ulule connect when api return a 401
 * @param  {object} action redux action
 * @return {object}        redux action
 */
export const unAuthorizedAPIError = action => {
  const next = encodeURIComponent(window.location.href)
  const lang = config.get('locale')
  const unprotectedUrls = getUnprotectedUrls()

  if (unprotectedUrls.indexOf(action.url) === -1) {
    const url = config.get('urls').signin + `?next=${next}&lang=${lang}`

    window.location = url
  }

  return action
}

export const forbiddenAPIError = action => {
  const next = encodeURIComponent(window.location.href)
  const lang = config.get('locale')

  window.location = config.get('urls').forbidden + `?next=${next}&lang=${lang}`

  return action
}
